import { Button, DatePicker, Form, Select, TimePicker } from "antd";
import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import apiClient from "../../../utils/apiClient";
import useToast from "../../../hooks/userToast";
import moment from "moment";
import useUser from "../../../hooks/useUser";

const { Option } = Select;
const { Item: FormItem } = Form;

AddRadiologistSlot.propTypes = {
  fetchData: PropTypes.func,
  handleClose: PropTypes.func,
};

function AddRadiologistSlot({ fetchData, handleClose }) {
  const { isRadiologist, userID } = useUser();
  const [form] = Form.useForm();
  const [radioData, setRadioData] = useState([]);
  const [startDate, setStartDate] = useState(null);
  const [startTime, setStartTime] = useState(null);
  const { toastSuccess, toastError, toastWarning } = useToast();

  const onSubmit = async (values) => {
    console.log("values", values);

    const startTime = values?.startTime?.format("HH:mm");
    const endTime = values?.endTime?.format("HH:mm");

    // Check if the start date is today
    const isStartDateToday = values?.startDate?.isSame(moment(), "day");

    if (isStartDateToday) {
      const currentHour = moment().hour();
      const currentMinute = moment().minute();
      const selectedHour = values?.startTime?.hour();
      const selectedMinute = values?.startTime?.minute();

      // Validate if the selected start time is before the current time
      if (
        selectedHour < currentHour ||
        (selectedHour === currentHour && selectedMinute < currentMinute)
      ) {
        toastWarning("Start Time cannot be before the current time.");
        return;
      }
    }

    // Check if the start date and end date are the same to validate the end time
    if (values?.startDate?.isSame(values?.endDate, "day")) {
      // Validate end time is not before start time
      if (moment(endTime, "HH:mm").isBefore(moment(startTime, "HH:mm"))) {
        toastWarning("End Time cannot be before Start Time on the same day.");
        return;
      }
    }

    let payload = {
      radiologist_id: !isRadiologist ? values?.selectedRadio : userID,
      start_date: values?.startDate?.startOf("day").format("YYYY-MM-DD"),
      end_date: values?.endDate?.startOf("day").format("YYYY-MM-DD"),
      start_time: startTime,
      end_time: endTime,
      status: "not booked",
    };

    try {
      await apiClient.post("availability/create", payload);
      toastSuccess("Event Created Successfully!");
      fetchData();
      form.resetFields();
      handleClose();
    } catch (error) {
      console.error("Error Creating Event", error);
      toastError(error.response?.data?.message || error?.message);
    }
  };

  const fetchAllRadio = async () => {
    try {
      const response = await apiClient.get("users?role=radiologist&limit=1000");
      // console.log("All Radiologists", response.data.users.data);
      setRadioData(response.data.users.data);
    } catch (error) {
      console.error("Error fetching radiologists:", error);
    }
  };

  useEffect(() => {
    fetchAllRadio();
  }, []);

  const disabledDate = (current) => {
    return current && current < moment().startOf("day");
  };

  const onStartDateChange = (date) => {
    setStartDate(date);
    form.setFieldsValue({ endDate: null });
  };

  const endDateDisabled = (current) => {
    return current && current < startDate;
  };

  const onStartTimeChange = (time) => {
    setStartTime(time);
    form.setFieldsValue({ endTime: null });
  };

  const endTimeDisabled = (current) => {
    if (!startTime) return false;
    return current && current.isBefore(startTime);
  };

  return (
    <>
      <Form onFinish={onSubmit} form={form}>
        <div className="row">
          <div className="col-12 manual_selecter edit_grade">
            {!isRadiologist && (
              <FormItem
                style={{ width: "70%" }}
                label="Select Radiologist"
                name="selectedRadio"
                rules={[{ required: true, message: "Radiologist required" }]}
              >
                <Select
                  showSearch
                  placeholder="Select Radiologist"
                  filterOption={(input, option) =>
                    option.children.toLowerCase().includes(input.toLowerCase())
                  }
                >
                  {radioData?.map((element) => (
                    <Option key={element?.id} value={element?.id}>
                      {element?.name}
                    </Option>
                  ))}
                </Select>
              </FormItem>
            )}
          </div>

          <div className="col-lg-6 edit_grade" style={{ overflowY: "auto" }}>
            <FormItem
              label="Start Date"
              name="startDate"
              rules={[{ required: true, message: "Start Date required" }]}
            >
              <DatePicker
                disabledDate={disabledDate}
                onChange={onStartDateChange}
              />
            </FormItem>
          </div>

          <div className="col-lg-6 edit_grade">
            <FormItem
              label="End Date"
              name="endDate"
              rules={[{ required: true, message: "End Date required" }]}
            >
              <DatePicker disabledDate={endDateDisabled} />
            </FormItem>
          </div>

          <div className="col-lg-6 edit_grade">
            <FormItem
              label="Start Time"
              name="startTime"
              rules={[{ required: true, message: "Start Time required" }]}
            >
              <TimePicker
                use12Hours
                format="h:mm A"
                onChange={onStartTimeChange}
              />
            </FormItem>
          </div>

          <div className="col-lg-6 edit_grade">
            <FormItem
              label="End Time"
              name="endTime"
              rules={[{ required: true, message: "End Time required" }]}
            >
              <TimePicker
                use12Hours
                format="h:mm A"
                disabledTime={endTimeDisabled}
              />
            </FormItem>
          </div>

          <div className="form-group login-btn d-flex gap-5 justify-content-center new_type_register edit_grade">
            <Button
              className="btn btn-primary btn-block w-25"
              type="submit"
              htmlType="submit"
            >
              Submit
            </Button>
          </div>
        </div>
      </Form>
    </>
  );
}

export default AddRadiologistSlot;
